

import React, { memo } from 'react';
import cx from 'classnames';
import ContentEditable from 'react-contenteditable';
import Button from '../Button';
import LabelWrapper from '../LabelWrapper';
import Text from '../Text';
import getValue from './utils/getValue';
import getDecrementDisabled from './utils/getDecrementDisabled';
import getSuffixLabel from './utils/getSuffixLabel';
import getHideValue from './utils/getHideValue';
import unlimitedOption from './constants/unlimitedOption';
import './styles/_number-changer.scss';




















function onClick(onChangeNumber, value, { increment } = {}, disableZero, allowUnlimitedOption) {
  return () => {
    const isValueAtBase = allowUnlimitedOption && value === unlimitedOption.value ||
    !allowUnlimitedOption && value === 0;
    const incrementBy = increment && isValueAtBase && disableZero ? 2 : 1;
    const decrementBy = !increment && value === 1 && disableZero ? -2 : -1;
    const calculatedVal = increment ? incrementBy : decrementBy;
    onChangeNumber(value + calculatedVal);
  };
}

function onChange(onChangeNumber) {
  return ({ target: { value } }) => {
    onChangeNumber(Number(value) || 0);
  };
}

function sanitiseInput(value) {
  return (e) => {
    const { key } = e;

    if (key === 'Backspace' && value !== 0 || !Number.isNaN(Number(key))) {return;}

    e.preventDefault();
    e.stopPropagation();
  };
}

function NumberChanger({
  value: givenValue,
  onChangeNumber,
  disabled,
  label,
  suffixLabel: givenSuffixLabel,
  max,
  hideValue: givenHideValue,
  labelProps,
  disableTextInput,
  allowUnlimitedOption = false,
  disableZero = false,
  isFullWidth = false,
  allowNegative = false,
  error = false,
  decrementDisabled = false,
  maxDisabled = false
}) {
  const value = getValue(givenValue, allowUnlimitedOption, disableZero);

  const isIncrementDisabled = disabled || maxDisabled || typeof max === 'number' && value >= max;

  const isDecrementDisabled = disabled ||
  decrementDisabled ||
  getDecrementDisabled(value, allowUnlimitedOption, disableZero, allowNegative);

  const suffixLabel = getSuffixLabel(givenSuffixLabel, value, allowUnlimitedOption);

  const hideValue = getHideValue(givenHideValue, value, allowUnlimitedOption);

  return (
    <LabelWrapper {...labelProps} divContainer className="number-changer__label-wrapper" label={label}>
      <div className={cx(
        'number-changer',
        { 'number-changer__full-width': isFullWidth }
      )}>

        <Button
          type="TERTIARY"
          className={cx(
            'number-changer__minus',
            { 'number-changer__minus--disabled': isDecrementDisabled }
          )}
          disabled={isDecrementDisabled}
          onClick={
          onClick(onChangeNumber, value, { increment: false }, disableZero, allowUnlimitedOption)}

          prefix="remove" />

        <div className={cx(
          'number-changer__text',
          { 'number-changer__text__error': error }
        )}>

          {!hideValue &&
          <ContentEditable
            className="text text--button text--centered number-changer__text__value"
            html={`${value}`}
            tagName="span"
            onChange={onChange(onChangeNumber)}
            onKeyDown={sanitiseInput(value)}
            disabled={disabled || disableTextInput} />}


          {suffixLabel && <Text button>{suffixLabel}</Text>}
        </div>
        <Button
          type="TERTIARY"
          className={cx(
            'number-changer__add',
            { 'number-changer__add--disabled': isIncrementDisabled }
          )}
          onClick={!isIncrementDisabled ?
          onClick(onChangeNumber, value, { increment: true }, disableZero, allowUnlimitedOption) :
          void 0}
          disabled={isIncrementDisabled}
          prefix="addfat" />

      </div>
    </LabelWrapper>);

}

export default memo(NumberChanger);